export default __webpack_public_path__ + "static/media/tema4.2e5455f0.jpg";